import { GenIcon } from '../helpers/IconBase.es.js';

const LineOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M14.125 7.4375H1.875C1.80625 7.4375 1.75 7.49375 1.75 7.5625V8.4375C1.75 8.50625 1.80625 8.5625 1.875 8.5625H14.125C14.1938 8.5625 14.25 8.50625 14.25 8.4375V7.5625C14.25 7.49375 14.1938 7.4375 14.125 7.4375Z",
          fill: "#A7ABC3"
        }
      }
    ]
  })(props);
};

export { LineOutlined };
